if (!customElements.get('size-guide')) {
  customElements.define(
    'size-guide',
    class SizeGuide extends HTMLElement {
      static CM_PER_INCH = 2.54;

      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.sizeButtons = [...this.querySelectorAll('[data-size-index]')];
        this.unitButtons = [...this.querySelectorAll('[data-unit]')];
        this.measures = [...this.querySelectorAll('[data-values]')];
        this.sizeIndex = 0;
        this.unit = 'cm';
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          maximumFractionDigits: 1,
        });

        this.sizeButtons.forEach((button) =>
          button.addEventListener('click', () => this.render(Number(button.dataset.sizeIndex), this.unit))
        );
        this.unitButtons.forEach((button) =>
          button.addEventListener('click', () => this.render(this.sizeIndex, button.dataset.unit))
        );

        this.querySelector('[data-size-guide-close]').addEventListener('click', () => this.dialog.close());
        // Close on backdrop clicks only: a drag that starts inside the panel also lands on the dialog.
        this.dialog.addEventListener('pointerdown', (event) => (this.pressedBackdrop = event.target === this.dialog));
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog && this.pressedBackdrop) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => document.body.classList.remove('overflow-hidden'));
      }

      open(size) {
        const wanted = size?.trim().toLowerCase();
        const index = this.sizeButtons.findIndex((button) => button.dataset.size.toLowerCase() === wanted);
        this.render(index >= 0 ? index : this.sizeIndex, this.unit);
        this.dialog.showModal();
        document.body.classList.add('overflow-hidden');
      }

      render(sizeIndex, unit) {
        this.sizeIndex = sizeIndex;
        this.unit = unit;

        this.sizeButtons.forEach((button, index) => button.setAttribute('aria-pressed', index === sizeIndex));
        this.unitButtons.forEach((button) => button.setAttribute('aria-pressed', button.dataset.unit === unit));

        const unitLabel = this.unitButtons.find((button) => button.dataset.unit === unit).textContent.trim();
        this.measures.forEach((measure) => {
          const cm = Number(measure.dataset.values.split(',')[sizeIndex]);
          const value = unit === 'in' ? cm / SizeGuide.CM_PER_INCH : cm;
          measure.querySelector('[data-value]').textContent = this.formatter.format(value);
          measure.querySelector('[data-unit-label]').textContent = unitLabel;
        });
      }
    }
  );

  // Delegated: the opener lives inside <variant-selects>, which is replaced on every variant change.
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-size-guide-opener]');
    if (!opener) return;

    const guide = document.getElementById(opener.getAttribute('aria-controls'));
    const selected = [...(opener.closest('variant-selects')?.querySelectorAll('input:checked') ?? [])].find(
      (input) => input.dataset.optionName === opener.dataset.sizeOption
    );
    guide?.open(selected?.value);
  });
}
